/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useEffect } from "react";
import qs from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import useCartStore from "../store/cartStore";
import { toast } from "sonner";
import useAuthMoadl from "../store/authWarningModal";
import useUserData from "../store/userStore";
import { handleGetLanguage } from "../utils/languageStorage";
import { checkQuantity } from "../api/cartApi";
import ShareButton from "./FaceBookShareButton";
import MobileAddToCartContainer from "./mobileAddToCartContainer";

export default function ProductDetail({
  product,
  selectedSize,
  setSelectedSize,
}) {
  const [count, setCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const { addToCart } = useCartStore((s) => s);
  const { show } = useAuthMoadl((s) => s);
  const { user } = useUserData((s) => s);

  const location = useLocation();
  const navigate = useNavigate();
  const language = handleGetLanguage();
  const sizes = product.sizes;

  const sizeRequired = sizes?.length > 0;
  const sizeNotChosen = sizeRequired && !selectedSize;

  const increments = () => setCount(count + 1);
  const decrements = () => count > 1 && setCount(count - 1);

  const translations = {
    en: {
      shopNow: "Shop Now",
      addToCart: "Add to Cart",
      productCode: "Code",
      size: "Size",
      quantity: "Quantity",
      colors: "Colors",
      youHaveToAdd: "You have to select a size",
      addedToCart: "Product added to cart",
      shareText: "Share",
      price: "Price",
    },
    ka: {
      shopNow: "ყიდვა",
      addToCart: "კალათაში დამატება",
      productCode: "კოდი",
      size: "ზომა",
      quantity: "რაოდენობა",
      colors: "ფერები",
      youHaveToAdd: "გთხოვთ, აირჩიეთ ზომა",
      addedToCart: "პროდუქტი კალათაში დაემატა",
      shareText: "გააზიარე",
      price: "ფასი",
    },
  };
  const t = translations[language] || translations.en;

  const referralFromQuery = new URLSearchParams(location.search).get("referral_code");

  const setSingleReferalInSession = () => {
    if (referralFromQuery)
      sessionStorage.setItem("other_referral_code", referralFromQuery);
    return sessionStorage.getItem("other_referral_code");
  };

  const guardSize = () => {
    if (sizeNotChosen) {
      toast.error(t.youHaveToAdd);
      return false;
    }
    return true;
  };



  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://webstatic.bog.ge/bog-sdk/bog-sdk.js?version=2&client_id=10000794";
    script.onload = () => {
      const container = document.querySelector(".bog-smart-button");
      if (!container) return;

      window.BOG.SmartButton.render(container, {
        text: "მოითხოვე სესხი",
        onClick: () => {
          if (sizeNotChosen) {
            // 🔹 show toast if no size selected
            toast.error("გთხოვთ, აირჩიეთ ზომა");
            return;
          }

          window.BOG.Calculator.open({
            amount: (product.discounted_price || product.price) * count,
            onRequest: (selected, successCb, closeCb) => {
              const { amount, month, discount_code } = selected;

              fetch("https://api.onlybrands.ge/api/payments/checkout/loan", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer 404|MHtO1kHBRKss6BicbNw9XPooAvBEEaHz7Oxqt4Fc0a496e20",
                },
                body: JSON.stringify({
                  city: "Tbilisi",
                  address: "Some Address",
                  name: user?.name ?? "User",
                  surname: user?.surname ?? "Doe",
                  phone_number: user?.phone_number ?? "+995555555555",
                  cart_items: [
                    {
                      product_id: product.id,
                      product_option_id: product.options?.find(
                        (opt) => opt.size_id === selectedSize?.id
                      )?.id ?? null,   // ✅ the correct option id from product.options
                      size_id: selectedSize?.id ?? null,
                      quantity: count,
                      price: product.discounted_price || product.price,
                    },
                  ],

                  amount: parseFloat(amount),
                  month: parseInt(month),
                  discount_code,
                }),
              })
                .then((res) => res.json())
                .then((data) => {
                  if (data.success && data.data?.id) {
                    successCb(data.data.id);
                  } else {
                    console.error("Loan order failed", data);
                    closeCb();
                  }
                })
                .catch((err) => {
                  console.error("Loan request error", err);
                  closeCb();
                });
            },
            onComplete: ({ redirectUrl }) => {
              if (redirectUrl) window.location.href = redirectUrl;
              return false;
            },
          });
        },
      });
    };
    document.body.appendChild(script);
  }, [product, selectedSize, count, sizeNotChosen, user]);

  const handleAddToCart = () => {
    if (!user?.id || !user?.email) {
      show();
      return;
    }
    if (!guardSize()) return;

    addToCart(
      {
        product_id: product.id,
        product,
        quantity: count,
        color_id: product.colors[0]?.id,
        size_id: selectedSize?.id ?? 0,
        price: product.discounted_price || product.price,
        ...(referralFromQuery && { referral: referralFromQuery }),
      },
      setIsLoading
    );
    setCount(1);
  };

  const handleShopNow = async () => {
    if (!user?.id || !user?.email) {
      show();
      return;
    }
    if (!guardSize()) return;

    const ok = await checkQuantity({
      id: product.id,
      colore: product.colors[0]?.id,
      size: selectedSize?.id ?? undefined,
      quantity: count,
    });

    if (ok === 200) {
      const referral = setSingleReferalInSession();
      const url = qs.stringifyUrl(
        {
          url: "/shop-checkout",
          query: {
            product: product.id,
            size: selectedSize?.id ?? undefined,
            qtn: count,
            referral,
          },
        },
        { skipNull: true, skipEmptyString: true }
      );
      navigate(url);
    }
  };

  const handleCopy = () => {
    if (!user.name || !user.referral_code) {
      show("signUp");
      return;
    }
    navigator.clipboard.writeText(
      `onlybrands.ge${location.pathname}?referral_code=${user.referral_code}`
    );
    toast.success(
      language === "ka"
        ? "რეფერალური ლინკი დაკოპირებულია ✔"
        : "Referral link copied ✔"
    );
  };

  const Row = ({ label, value }) => (
    <div className="flex items-center justify-between border-b-2 last:border-b-0 text-sm">
      <div>{label}</div>
      <div>{value}</div>
    </div>
  );

  return (
    <div>
      {/* Mobile sticky bar */}
      <MobileAddToCartContainer
        textOne={t.addToCart}
        textTwo={t.shopNow}
        handleAddToCart={handleAddToCart}
        handleShopNow={handleShopNow}
      />

      {/* Mobile Top: Name + Code */}
      <div className="md:hidden flex flex-col gap-2">
        <h5 className="text-base font-semibold">{product.name?.[language]}</h5>
        <div className="text-xs text-gray-600">
          {t.productCode}: <span className="text-black">{product.overview?.[language]}</span>
        </div>
      </div>

      {/* Mobile Price + Buttons */}
      <div className="md:hidden mt-2 flex flex-col gap-2">
        <div className="flex items-baseline gap-2">
          <span className="text-lg font-bold text-black">{product.discounted_price} GEL</span>
          {product.price && (
            <del className="text-red-600 text-sm">{product.price} GEL</del>
          )}
        </div>

        <div className="flex gap-2 w-full">
          <button
            onClick={handleCopy}
            className="text-white bg-orange-500 text-xs px-3 py-1 rounded-md w-full"
          >
            {language === "ka" ? "გააზიარე რეფერალი" : "Share Referral"}
          </button>
          <ShareButton
            text={t.shareText}
            language={language}
            product={product}
            referralLink={`onlybrands.ge${location.pathname}?referral_code=${user.referral_code}`}
            className="w-full text-white bg-orange-500 text-xs px-3 py-1 rounded-md"
          />
        </div>
      </div>

      {/* Desktop Title & Price */}
      <h5 className="hidden md:flex text-2xl font-semibold mt-2">{product.name?.[language]}</h5>
      <div className="hidden md:flex items-center gap-2 mt-2">
        <h5 className="text-lg font-semibold">{t.price}:</h5>
        <span className="text-2xl font-bold text-black">{product.discounted_price} GEL</span>
        {product.price && (
          <del className="text-red-600 text-lg">{product.price} GEL</del>
        )}
      </div>

      {/* Desktop Product Code */}
      <div className="hidden md:flex items-baseline gap-2 mt-4">
        <h5 className="text-lg font-semibold">{t.productCode}:</h5>
        <p className="text-slate-400">{product.overview?.[language]}</p>
      </div>

      {/* Quantity Selector */}
      <div className="mt-6">
        <h5 className="font-semibold mb-2">{t.quantity}:</h5>
        <div className="flex items-center gap-2">
          <button
            onClick={decrements}
            className="w-9 h-9 text-lg rounded-md bg-orange-100 text-orange-500 hover:bg-orange-500 hover:text-white"
          >
            -
          </button>
          <input
            readOnly
            value={count}
            className="w-12 h-9 text-center rounded-md border border-orange-300"
          />
          <button
            onClick={increments}
            className="w-9 h-9 text-lg rounded-md bg-orange-100 text-orange-500 hover:bg-orange-500 hover:text-white"
          >
            +
          </button>
        </div>
      </div>

      {/* Desktop Action Buttons */}
      {/* Desktop Action Buttons */}
      <div className="hidden md:flex flex-col gap-3 mt-6">
        <button
          onClick={handleAddToCart}
          className="py-2 px-4 text-sm font-semibold rounded-md bg-orange-500 text-white hover:bg-orange-400"
        >
          {t.addToCart}
        </button>
        <button
          onClick={handleShopNow}
          className="py-2 px-4 text-sm font-semibold rounded-md bg-orange-500 text-white hover:bg-orange-400"
        >
          {t.shopNow}
        </button>
        <div className="mt-4 flex flex-col items-center">
          <div className="bog-smart-button w-full text-center"></div>
        </div>
      </div>
      <div className="hidden md:flex gap-2 mt-3">
        <ShareButton
          text={t.shareText}
          language={language}
          product={product}
          referralLink={`onlybrands.ge${location.pathname}?referral_code=${user.referral_code}`}
        />
        <button
          onClick={handleCopy}
          className="py-2 px-3 rounded-md text-sm bg-orange-500 text-white hover:bg-orange-400"
        >
          {language === "ka" ? "გააზიარე რეფერალი" : "Share Referral"}
        </button>
      </div>

      {/* Product Info */}
      <div className="mt-5 flex flex-col gap-2">
        <Row label={language === "ka" ? "ბრენდი" : "Brand"} value={product.name?.[language]} />
        <Row label={language === "ka" ? "სტატუსი" : "Status"} value={product.status?.[language]} />
        <Row label={language === "ka" ? "იმპორტირებული" : "Imported"} value={product.country?.name[language]} />
        <Row label={language === "ka" ? "კატეგორია" : "Category"} value={product.categories[0]?.name?.[language]} />
        <Row label={language === "ka" ? "სქესი" : "Sex"} value={product.genders[0]?.name?.[language]} />
        <Row label={language === "ka" ? "შემადგენლობა" : "Composition"} value={product.composition?.[language]} />
        <Row label={language === "ka" ? "ფერი" : "Color"} value={product.colors[0]?.name?.[language]} />
      </div>
    </div>
  );
}
